import { formatCurrency } from "@/utils/currencyUtils";

interface LoanBasicInfoProps {
  purpose: string | null;
  created_at: string;
  amount: number;
}

export const LoanBasicInfo = ({
  purpose,
  created_at,
  amount
}: LoanBasicInfoProps) => {
  return (
    <div className="grid grid-cols-2 gap-4">
      <div>
        <p className="text-sm font-medium text-muted-foreground">Purpose</p>
        <p className="text-sm mt-1">{purpose || 'Not specified'}</p>
      </div>
      <div>
        <p className="text-sm font-medium text-muted-foreground">Application Date</p>
        <p className="text-sm mt-1">
          {new Date(created_at).toLocaleDateString()}
        </p>
      </div>
      <div className="col-span-2">
        <p className="text-sm font-medium text-muted-foreground">Loan Amount</p>
        <p className="text-sm mt-1">
          {formatCurrency(amount, "GHS")}
        </p>
      </div>
    </div>
  );
};